import { useState } from 'react';
import { apiSend, useMe } from '../../api/client';

/** Inline report control: pick a reason, submit once, then stays disabled. */
export function ReportButton({
  targetType,
  targetId,
}: {
  targetType: 'comment' | 'screenshot';
  targetId: string;
}) {
  const me = useMe();
  const [open, setOpen] = useState(false);
  const [reason, setReason] = useState('spam');
  const [done, setDone] = useState(false);
  const [error, setError] = useState<string | null>(null);
  const user = me.data?.user ?? null;
  if (!user || user.banned) return null;
  if (done) return <span className="muted">Reported</span>;
  if (!open) {
    return (
      <button
        type="button"
        className="vote-arrow"
        style={{ color: 'var(--muted)' }}
        onClick={() => setOpen(true)}
      >
        report
      </button>
    );
  }
  const submit = async () => {
    setError(null);
    try {
      await apiSend('POST', '/api/reports', { targetType, targetId, reason });
      setDone(true);
    } catch (err) {
      setError((err as Error).message || 'Report failed');
    }
  };
  return (
    <span className="actions" style={{ display: 'inline-flex' }}>
      <select aria-label="Report reason" value={reason} onChange={(e) => setReason(e.target.value)}>
        <option value="spam">spam</option>
        <option value="abuse">abuse</option>
        <option value="wrong">wrong information</option>
        <option value="other">other</option>
      </select>
      <button type="button" onClick={submit}>
        Report
      </button>
      <button type="button" onClick={() => setOpen(false)}>
        Cancel
      </button>
      {error && <span className="error">{error}</span>}
    </span>
  );
}
